import { useTranslation } from '../hooks';

export const Title = () => {
  const { t } = useTranslation();

  return <span data-test={t('insights.title')}>{t('insights.title')}</span>;
};
